export const CALCULATOR_CONFIG = {
  systemTypes: [
    {
      id: "luft-til-vand",
      name: "Luft til vand varmepumpe",
      basePrice: 85000,
      description: "Ideel til helårshuse med radiatorer eller gulvvarme. Inkluderer inde- og udedel samt standard montering."
    },
    {
      id: "luft-til-luft",
      name: "Luft til luft varmepumpe",
      basePrice: 15500,
      description: "Perfekt som primær varme i sommerhus eller effektiv supplerende varme i helårshus."
    },
    {
      id: "pillefyr",
      name: "Træpillefyr / Stokerfyr",
      basePrice: 54000,
      description: "Stabil og CO2-neutral opvarmning til helårshuse, landejendomme og erhverv."
    },
    {
      id: "solceller",
      name: "Solcelleanlæg",
      basePrice: 48000,
      description: "Producér din egen grønne strøm til husholdningen og varmepumpen."
    }
  ],

  houseSizes: [
    { id: "under-100", label: "Under 100 m²", multiplier: 1.0 },
    { id: "100-150", label: "100 - 150 m²", multiplier: 1.12 },
    { id: "151-200", label: "151 - 200 m²", multiplier: 1.25 },
    { id: "201-300", label: "201 - 300 m²", multiplier: 1.38 },
    { id: "over-300", label: "Over 300 m²", multiplier: 1.55 }
  ],

  currentHeatSources: [
    { id: "oliefyr", label: "Oliefyr (skal nedtages)", fee: 11500 },
    { id: "naturgas", label: "Naturgasfyr", fee: 8500 },
    { id: "elvarme", label: "Elvarme / Elradiatorer", fee: 4000 },
    { id: "gammelt-pillefyr", label: "Gammelt pillefyr / fast brændsel", fee: 5500 },
    { id: "intet-skal-udskiftes", label: "Nyetablering / Intet anlæg skal fjernes", fee: 0 }
  ],

  insulationLevels: [
    { id: "god", label: "God isolering (Nyere hus / Energimærke A-B)", fee: 0 },
    { id: "middel", label: "Middel isolering (Bygget 1980-2010 / C-D)", fee: 3200 },
    { id: "aeldre", label: "Ringe / Ældre isolering (Før 1980 / E-G)", fee: 6500 }
  ],

  addOns: [
    { id: "demontering", label: "Nedtagning og bortskaffelse af gammelt anlæg", price: 4500 },
    { id: "varmtvandsbeholder", label: "Ny 200L emaljeret varmtvandsbeholder", price: 11800 },
    { id: "ekstraRorfoering", label: "Ekstra rørføring ud over 5 meter", price: 3400 },
    { id: "betonsokkel", label: "Støbt betonsokkel til udedel", price: 2900 },
    { id: "wifiModule", label: "WiFi modul for app-styring og overvågning", price: 1800 }
  ]
};

export function calculateEstimate({ systemTypeId, houseSizeId, currentHeatId, insulationId, selectedAddOns = [] }) {
  const system = CALCULATOR_CONFIG.systemTypes.find(s => s.id === systemTypeId) || CALCULATOR_CONFIG.systemTypes[0];
  const size = CALCULATOR_CONFIG.houseSizes.find(s => s.id === houseSizeId) || CALCULATOR_CONFIG.houseSizes[1];
  const heat = CALCULATOR_CONFIG.currentHeatSources.find(h => h.id === currentHeatId) || CALCULATOR_CONFIG.currentHeatSources[0];
  const insulation = CALCULATOR_CONFIG.insulationLevels.find(i => i.id === insulationId) || CALCULATOR_CONFIG.insulationLevels[0];

  let base = Math.round(system.basePrice * size.multiplier);
  let heatFee = heat.fee;
  let insulationFee = insulation.fee;
  
  let addOnsTotal = selectedAddOns.reduce((sum, addOnId) => {
    const item = CALCULATOR_CONFIG.addOns.find(a => a.id === addOnId);
    return sum + (item ? item.price : 0);
  }, 0);

  let totalInclVat = base + heatFee + insulationFee + addOnsTotal;
  let totalExclVat = Math.round(totalInclVat / 1.25);
  let vatAmount = totalInclVat - totalExclVat;

  return {
    systemName: system.name,
    base,
    heatFee,
    insulationFee,
    addOnsTotal,
    totalInclVat,
    totalExclVat,
    vatAmount
  };
}
